// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2ClLJ","content":"ManualTimeModal_content__3PdFf"};